import { useCallback, useMemo } from 'react';

import { FinancialConfigResource } from '../queries/financialConfig';
import { FinancialConfigView } from '../views/FinancialConfigView/FinancialConfigView';
import { useApiView } from './useApiView';

export const useFinancialConfig = (resource: FinancialConfigResource | null) => {
  const workspaceId = resource?.workspaceId;
  const entityType = resource?.entityType;
  const entityId = resource?.entityId;
  const hasAllParams = !!workspaceId && !!entityType && !!entityId;
  const financialConfigView = useMemo(
    () => new FinancialConfigView(
      workspaceId && entityType && entityId ? { workspaceId, entityType, entityId } : null
    ),
    [workspaceId, entityType, entityId]
  );
  const view = useApiView(financialConfigView);
  const reload = useCallback(() => view.reload(), [view]);

  return {
    error: view.state.errorLoading,
    financialConfig: view.state.financialConfig,
    hasAllParams,
    isFetching: view.state.isFetching,
    isLoading: view.state.isLoading,
    reload
  };
};
